import React from "react";

const BioModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 overflow-y-auto">
      <div className="bg-white p-4 sm:p-6 md:p-8 rounded-lg max-w-3xl w-full max-h-[90vh] overflow-y-auto my-4">
        <div className="flex justify-between items-start gap-4 mb-4">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 flex-1">Patrick Driscoll, Broker</h2>
          <button onClick={onClose} className="flex-shrink-0 min-w-[44px] min-h-[44px] flex items-center justify-center text-2xl font-bold text-gray-500 hover:text-gray-700 touch-manipulation" aria-label="Close">&times;</button>
        </div>
        <p className="text-base sm:text-lg md:text-xl mb-6 sm:mb-8 text-gray-700 leading-relaxed">
          Patrick Driscoll is a dedicated REALTOR and Broker with Driscoll Co, LLC, proudly serving St. Louis and the surrounding Missouri counties. A long-time resident of Kirkwood, Missouri, Patrick has deep roots in the St. Louis metropolitan area and an intimate understanding of its diverse neighborhoods and real estate markets. With a career spanning nearly two decades, Patrick has been a licensed real estate agent since 2004. His extensive experience covers residential, commercial, and investment properties, as well as landlord and tenant representation. When not assisting clients, Patrick can often be found enjoying the many amenities Kirkwood and St. Louis have to offer.
        </p>
      </div>
    </div>
  );
};

export default BioModal;
